export default __webpack_public_path__ + "static/media/windows.dd90ac6b.svg";